export enum AbsenceSicknessSubTypeEnumeration {
	PSYCHIC = 'illnessMentalIllness',
	BACK = 'illnessBackProblems',
	OTHER = 'illnessOther',
	UNKNOWN = 'illnessUnknown',
}
